import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Store } from '@ngxs/store';
import * as Sentry from "@sentry/angular";
import * as FlatModels from "@medsurf/flat-models";
import { AuthControlState } from '@medsurf/flat-states';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Sentry Init
Sentry.init({
  dsn: environment.config.sentry.dsn,
  environment: environment.config.sentry.environment,
  tracesSampleRate: 1,
  release: environment.config.version,
  beforeSend(event, hint) {
    if (hint.originalException['instance'] && hint.originalException['instance'] === FlatModels.ErrorControlModels.ErrorInstance.enum.API) {
      return null;
    }
    return event;
  },
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.category === 'xhr') {
      if (hint.input) {
        // Get Data
        const input = JSON.parse(hint.input);
        
        // Add Request Type
        if (input.type) {
          breadcrumb.data.type = input.type;
        }
        
        // Remove Critical Values
        delete input.type;
        delete input.token;
        delete input.password;
        delete input.password_confirm;
        
        // Add Request Data
        let hasRequestData = false;
        const requestData = {};
        for (const entry of Object.getOwnPropertyNames(input)) {
          requestData[entry] = input[entry];
          hasRequestData = true;
        }
        if (hasRequestData) {
          breadcrumb.data.requestData = requestData;
        }
      }
    }
    return breadcrumb;
  }
});

// Angular
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then((ref: NgModuleRef<AppModule>) => {
    const store = ref.injector.get(Store);
    store.select(AuthControlState.currentUser$).subscribe((user) => {
      if (user) {
        Sentry.setUser({
          id: user.id.toString(),
          username: `${user.firstName} ${user.lastName}`,
        });
        Sentry.setContext('user', user);
      }
    });
  })
  .catch(err => console.error(err));
